// People an admin should give a Hire Date (plan 080): active, not 1099 contractors, no date.
// Blank hire_date counts as "whole period" for PTO accrual and is the anchor for
// I-9 retention, FMLA 12-month eligibility and the ACA look-back.
export function peopleMissingHireDate(people) {
  const norm = (s) => String(s || '').toLowerCase();
  return (Array.isArray(people) ? people : [])
    .filter((p) => p && p.is_active !== false && p.employee_type !== 'contractor' && !p.hire_date)
    .sort((a, b) => norm(a.last_name).localeCompare(norm(b.last_name)) || norm(a.first_name).localeCompare(norm(b.first_name)));
}
